import { Link, useNavigate } from "react-router-dom";
import NavBar from "@src/components/NavBar";
import PageFooter from "../Home/PageFooter";
import styles from "./index.module.scss";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <NavBar active onLogoClick={() => navigate("/")} />
      <main className={styles.main}>
        <h1 className={styles.title}>Page not found</h1>
        <p className={styles.desc}>The page you requested does not exist.</p>
        <Link className={styles.link} to="/">
          Back to Primus
        </Link>
      </main>
      <PageFooter />
    </div>
  );
}
